"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.playScoreShowProps = exports.default = void 0;

var _vue = require("vue");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var playScoreShowProps = {
  score: {
    type: Boolean,
    default: false
  },
  totalScore: {
    type: Number,
    default: 0
  }
};
exports.playScoreShowProps = playScoreShowProps;
var PlayScoreShow = (0, _vue.defineComponent)({
  name: 'PlayScoreShow',
  props: playScoreShowProps,
  setup: function setup(props) {
    var score = (0, _vue.ref)(props.score);
    var totalScore = (0, _vue.computed)(function () {
      return parseInt(props.totalScore + '');
    });
    var showScore = (0, _vue.ref)(false);
    (0, _vue.watch)(function () {
      return props.score;
    }, function (newVal) {
      (0, _extends2.default)(score, newVal);
      showScore.value = newVal;
    }, {
      immediate: true
    });
    return {
      showScore: showScore,
      score: score,
      totalScore: totalScore
    };
  },
  render: function render() {
    return (0, _vue.withDirectives)((0, _vue.createVNode)("div", {
      "class": "play-score-show"
    }, [(0, _vue.createVNode)("div", {
      "class": "scoreContainer"
    }, [(0, _vue.createVNode)("div", {
      "class": "inContainer"
    }, [(0, _vue.createVNode)("div", {
      "class": "scoreContent"
    }, [(0, _vue.createVNode)("h2", null, [this.totalScore]), (0, _vue.createVNode)("span", null, [(0, _vue.createTextVNode)("\u603B\u5F97\u5206")])])])]), (0, _vue.createVNode)("div", {
      "class": "outRing",
      "style": "clip-path: inset(0 0 ".concat(this.totalScore * 1.6, "px 0)")
    }, null)]), [[_vue.vShow, this.showScore]]);
  }
});

PlayScoreShow.install = function (app) {
  app.component(PlayScoreShow.name, PlayScoreShow);
  return app;
};

var _default = PlayScoreShow;
exports.default = _default;